import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_10: FaireProductEntity = {
  token: "catalog_prod_prod-10",
  type: "product",
  name: "Balloon Garland Kit - Pastel Rainbow",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=400&fit=crop",
  priceDollars: 35.09,
  msrpDollars: 87.73,
  sku: "CO0010",
  caseSize: 3,
  material: "Wood",
  collectionToken: "col_confetti-cake",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 56,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  categoryTokens: ["catalog_cat_book-accessories"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
